import { Routes } from '@angular/router';
import { authGuard } from '../auth/auth.guard';
import { CustomerViewComponent } from './customer-view/customer-view.component';
import { CustomerEditComponent } from './customer-edit/customer-edit.component';

export const CUSTOMER_ROUTES: Routes = [
  {
    path: 'profile',
    component: CustomerViewComponent,
    canActivate: [authGuard]
  },
  {
    path: 'profile/edit',
    component: CustomerEditComponent,
    canActivate: [authGuard]
  }
];
